import { FrontendSurfaceConfig } from './types';

export const SURFACE_VENDOR_DASHBOARD_TENANTS = 'vendor_dashboard_tenants';

export const vendorDashboardTenantsSurface: FrontendSurfaceConfig = {
  surfaceKey: SURFACE_VENDOR_DASHBOARD_TENANTS,
  searchPlaceholder: 'Search tenants…',
  sortOptions: [
    { label: 'Name (A–Z)', value: 't.name:asc' },
    { label: 'Name (Z–A)', value: 't.name:desc' },
    { label: 'Connected (newest)', value: 'vr.accepted_at:desc' },
    { label: 'Connected (oldest)', value: 'vr.accepted_at:asc' },
    { label: 'Tier', value: 't.tier:asc' },
  ],
  filterOptions: [
    {
      key: 't.tier',
      label: 'Tier',
      options: [
        { label: 'Enterprise', value: 'enterprise' },
        { label: 'Professional', value: 'professional' },
        { label: 'Starter', value: 'starter' },
      ],
    },
  ],
  viewModes: [
    { mode: 'cards', label: 'Cards', icon: 'grid' },
    { mode: 'table', label: 'Table', icon: 'list' },
  ],
  defaultViewMode: 'cards',
  defaultPageSize: 20,
};

export const SURFACE_REGISTRY: Record<string, FrontendSurfaceConfig> = {
  [SURFACE_VENDOR_DASHBOARD_TENANTS]: vendorDashboardTenantsSurface,
};
